export default {
	"100": "银川市",
	"101": "洛阳市",
	"103": "阿勒泰",
	"104": "吐鲁番",
	"105": "宝泉岭",
	"107": "盘锦市",
	"108": "淄博市",
	"112": "威海市",
	"113": "潮州市",
	"114": "淮南市",
	"115": "陇南市",
	"116": "丽江市",
	"117": "日照市",
	"120": "枣庄市",
	"121": "东营市",
	"122": "潍坊市",
	"123": "滨州市",
	"124": "德州市",
	"125": "聊城市",
	"126": "菏泽市",
	"127": "莱芜市",
	"128": "辽阳市",
	"129": "海口市",
	"130": "内江市",
	"131": "牡丹江市",
	"133": "绵阳市",
	"135": "广汉市",
	"137": "滕州市",
	"138": "漳州市",
	"139": "铁岭市",
	"145": "泰州市",
	"027": "北京市",
	"034": "上海市",
	"040": "广州市",
	"014": "深圳市",
	"004": "杭州市",
	"006": "天津市",
	"007": "成都市",
	"003": "重庆市",
	"019": "佛山市",
	"009": "青岛市",
	"912": "青岛市",
	"913": "青岛市",
	"010": "郑州市",
	"000": "武汉市",
	"036": "厦门市",
	"021": "中山市",
	"001": "乌鲁木齐",
	"008": "东莞市",
	"011": "苏州市",
	"015": "瑞安市",
	"016": "惠州市",
	"020": "太原市",
	"022": "南昌市",
	"023": "许昌市",
	"024": "开封市",
	"025": "邯郸市",
	"026": "焦作市",
	"028": "嘉兴市",
	"029": "南阳市",
	"030": "安阳市",
	"031": "商丘市",
	"032": "驻马店市",
	"033": "新乡市",
	"035": "沈阳市",
	"038": "张家口市",
	"039": "赣州市",
	"018": "南京市",
	"044": "绍兴市",
	"042": "昌吉市",
	"045": "宁波市",
	"041": "济南市",
	"046": "南宁市",
	"043": "拉萨市",
	"047": "福州市",
	"053": "石家庄市",
	"054": "无锡市",
	"056": "唐山市",
	"057": "徐州市",
	"058": "常州市",
	"059": "泉州市",
	"048": "温州市",
	"051": "莆田市",
	"055": "南通市",
	"060": "大连市",
	"052": "烟台市",
	"061": "长春市",
	"067": "包头市",
	"069": "保定市",
	"070": "岳阳市",
	"071": "鞍山市",
	"066": "长沙市",
	"074": "三亚市",
	"062": "淮安市",
	"049": "呼和浩特",
	"076": "西安市",
	"078": "临沂市",
	"068": "台州市",
	"073": "吉林市",
	"079": "精河县",
	"080": "台北市",
	"083": "贵阳市",
	"081": "昆明市",
	"093": "泰安市",
	"091": "济宁市",
	"094": "长治市",
	"085": "香港市",
	"082": "沧州市",
	"099": "祁阳市",
	"095": "秦皇岛市",
	"096": "哈尔滨市",
	"134": "江门市",
	"143": "桂平市",
	"248": "开远市",
	"165": "曲靖市",
	"275": "宝鸡市",
	"261": "盘州市",
	"296": "芜湖市",
	"278": "河源市",
	"301": "舟山市",
	"303": "贺州市",
	"218": "晋城市",
	"329": "黄山市",
	"241": "韶关市",
	"169": "梧州市",
	"320": "达州市",
	"178": "晋中市",
	"262": "滁州市",
	"141": "陵水市",
	"374": "宿州市",
	"257": "东兴市"
};
